import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "_helpers";
// create slice = combination of reducer and action

const name = "pdfdownload";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });
//each slice have 3 elements first is name second is state, then reducer

// exports

export const pdfDownloadActions = { ...slice.actions, ...extraActions };
export const pdfDownloadReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state from local storage to enable user to stay logged in
    pdfData: [],
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}/po/generatePdfReview`;

  return {
    pdfDownload: pdfDownload(),
    //createPostSchedule: createPostSchedule(),
  };
  function pdfDownload() {
    return createAsyncThunk(
      `${name}/generatePdfReview`,
      async (id) => await fetchWrapper.get(`${baseUrl}/${id}`)
    );
  }
}
function createExtraReducers() {
  return (builder) => {
    pdfDownload();
    function pdfDownload() {
      var { pending, fulfilled, rejected } = extraActions.pdfDownload;
      builder
        .addCase(rejected, (state, action) => {
          state.pdfData = { error: action.error, loading: false };
        })
        .addCase(pending, (state) => {
          state.pdfData = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.pdfData = { value: action.payload };
          state.pdfData = { loading: false };
        });
    }
  };
}
